'use client'

import { FunctionComponent } from 'react'
import useOneTrustBanner from '../../hooks/useOneTrustBanner.hook'
import { PageDto } from '../../types/page.types'

interface Props {
  pageDto: PageDto
}

const OneTrustOverride: FunctionComponent<Props> = ({ pageDto }) => {
  useOneTrustBanner(pageDto)

  return null
}

export default OneTrustOverride
